import Reveal from "../components/Reveal";
import { Link } from "react-router-dom";
import { IMG } from "../data/content";

export default function Wildlife() {
  return (
    <section id="wildlife" data-testid="wildlife-section" className="mx-auto max-w-7xl scroll-mt-20 px-6 py-24 sm:px-12 sm:py-32 lg:px-20 lg:py-40">
      <div className="grid items-center gap-14 lg:grid-cols-5 lg:gap-16">
        <div className="lg:col-span-2">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-brass">Wildlife</p>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-3xl font-light leading-tight tracking-tight text-ivory sm:text-4xl lg:text-5xl">
              <Link data-testid="home-wildlife-page-link" to="/wildlife" className="text-inherit no-underline">
                You never know <span className="italic text-brass">what you'll see.</span>
              </Link>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-base font-light leading-relaxed text-ivory/75 sm:text-lg">
              Wildlife here is not a scheduled performance. It is a possibility — a pugmark
              on the morning trail, alarm calls drifting across the river, movement at the
              waterhole after dark.
            </p>
            <p className="mt-5 text-sm leading-relaxed text-ivory/55 sm:text-base">
              The forests of Corbett hold tiger, leopard and elephant, and over 600 species
              of birds. What you meet is up to the forest.
            </p>
          </Reveal>
        </div>
        <div className="grid grid-cols-2 gap-5 lg:col-span-3">
          <Reveal className="group overflow-hidden">
            <img
              data-testid="wildlife-image-1"
              src={IMG.wildlife1}
              alt="A tiger walking a night trail near The Jamoon in Corbett"
              loading="lazy"
              className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </Reveal>
          <Reveal delay={0.12} className="group mt-10 overflow-hidden">
            <img
              data-testid="wildlife-image-2"
              src={IMG.wildlife2}
              alt="A deer reflected in water near The Jamoon in Corbett"
              loading="lazy"
              className="aspect-square w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}
